import MkuDropdown from './src/dropdown';

MkuDropdown.install = function (Vue) {
  Vue.component(MkuDropdown.name, MkuDropdown);
};

export default MkuDropdown;
